export default __webpack_public_path__ + "static/media/traits_example.6ed7fb13.png";